var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.89 5.87891H5.10999C3.39999 5.87891 2 7.27889 2 8.98889V20.3489C2 21.7989 3.04 22.4189 4.31 21.7089L8.23999 19.5189C8.65999 19.2889 9.34 19.2889 9.75 19.5189L13.68 21.7089C14.95 22.4189 15.99 21.7989 15.99 20.3489V8.98889C16 7.27889 14.6 5.87891 12.89 5.87891Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.98889V20.3489C16 21.7989 14.96 22.4089 13.69 21.7089L9.76001 19.5189C9.34001 19.2889 8.65999 19.2889 8.23999 19.5189L4.31 21.7089C3.04 22.4089 2 21.7989 2 20.3489V8.98889C2 7.27889 3.39999 5.87891 5.10999 5.87891H12.89C14.6 5.87891 16 7.27889 16 8.98889Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.10999V16.47C22 17.92 20.96 18.53 19.69 17.83L16 15.77V8.98999C16 7.27999 14.6 5.88 12.89 5.88H8V5.10999C8 3.39999 9.39999 2 11.11 2H18.89C20.6 2 22 3.39999 22 5.10999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate2);
export default __webpack_public_path__ + "static/media/duplicate-2.3faf8ec95b3ab1677a6308dd476134d5.svg";
export { ForwardRef as ReactComponent };